import { useNavigator } from '@repo/toolkit/use-navigator'
import { SettingIcon } from '@repo/ui/icons'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { getPromoCode } from '../../../api/promo-codes/get-promo-code'
import { updatePromoCode } from '../../../api/promo-codes/update-promo-code'
import { ItemNotFound } from '../../../components/elements/item-not-found'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import UserNavBar from '../../../components/elements/nav-bar'
import PromoCodeForm from '../../../components/pages/promo-code/promo-code-form'
import { Paths } from '../../../lib/constants/path'
import { updateButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import NotFoundPage from '../../common/not-found'
import { mapPromoCodeIntoInput } from './utils'

const PromoCodeUpdatePage = () => {
  const { id } = useParams<{ id: string }>()
  const { navigate, back } = useNavigator()
  const queryClient = useQueryClient()

  if (!id || isNaN(+id)) return <ItemNotFound title="Identifiant de code promo invalide" />

  const { mutateAsync } = useMutation({
    mutationFn: updatePromoCode,
    onError: showAxiosError,
    onSuccess() {
      queryClient.invalidateQueries({ exact: true, queryKey: ['promo-codes', id] })
      toast.success('Code promo modifié avec succès')
    }
  })

  const { data, isLoading } = useQuery({
    queryKey: ['promo-codes', id],
    queryFn: () => getPromoCode(+id)
  })

  if (isLoading) return <LoadingScreen />
  if (!data) return <NotFoundPage />

  return (
    <div>
      <UserNavBar title={`Modifier le code promo ${data.name}`} icon={SettingIcon} />
      <div className={'h-4'} />
      <PromoCodeForm
        defaultValues={mapPromoCodeIntoInput(data)}
        buttonsConfig={updateButtonsConfig({
          onCancel: () => back(Paths.PROMO_CODE_LIST_PAGE),
          onUpdate: (values) => mutateAsync({ id: data.id, ...values }),
          onUpdateThenCreate: async (values) => {
            await mutateAsync({ id: data.id, ...values })
            navigate(Paths.PROMO_CODE_CREATE_PAGE)
          },
          onUpdateThenList: async (values) => {
            await mutateAsync({ id: data.id, ...values })
            navigate(Paths.PROMO_CODE_LIST_PAGE, { replace: true })
          }
        })}
      />
    </div>
  )
}
export default PromoCodeUpdatePage
